<template>
    <div class="main-content">
        <b-row>
            <b-col xl="3" lg="4" md="12" class="pr-1">

                <b-card class="box">
                    <div class="d-flex justify-content-between">
                        <span class="text-18 mb-3">{{ !isEditing ? 'Adicionar' : 'Editar' }}</span>
                        <b-button v-if="isEditing" @click="cancelEdditing" class="p-0 border-0 shadow-none mt-1 text-12 d-inline-flex align-items-start">Cancelar</b-button>
                    </div>

                    <div class="field mb-3">
                        <label><h6 class="font-weight-100">Título</h6></label>
                        <b-form-input v-model="milestone.title"></b-form-input>
                    </div>

                    <div class="field mb-3">
                        <label><h6 class="font-weight-100">Data</h6></label>
                        <b-form-input v-model="milestone.startDate" class="input" type="date"></b-form-input>
                    </div>

                    <div class="d-flex justify-content-between">
                        <b-button variant="primary" @click.prevent="!isEditing ? addMilestone() : editMilestone()">Salvar</b-button>
                        <b-button v-if="isEditing" size="sm" variant="danger" @click="deleteMilestone">Excluir</b-button>
                    </div>
                </b-card>

            </b-col>

            <b-col xl="9" lg="8" md="12" sm="12" class="pl-1">
                <b-card title="Agenda de Milestones">
                    <div class="calendar-parent">
                        <calendar-view
                            :items="milestones"
                            :show-date="showDate"
                            :enable-drag-drop="true"
                            :disable-past="disablePast"
                            :disable-future="disableFuture"
                            :display-period-count="displayPeriodCount"
                            :class="themeClasses"
                            :period-changed-callback="periodChanged"
                            @drop-on-date="onDrop"
                            @click-date="onClickDay"
                            @click-item="onClickItem"
                        >
                            <calendar-view-header
                                slot="header"
                                slot-scope="{ headerProps }"
                                :header-props="headerProps"
                                @input="setShowDate"
                            />
                        </calendar-view>
                    </div>
                </b-card>
            </b-col>
        </b-row>
    </div>
</template>
<script>
import {
    CalendarView,
    CalendarViewHeader,
    CalendarMathMixin,
} from 'vue-simple-calendar'
import { getFullDate } from '@/helpers/helper'
import firebase from 'firebase/app'

require('vue-simple-calendar/static/css/default.css')

export default {
    components: {
        CalendarView,
        CalendarViewHeader,
    },
    mixins: [CalendarMathMixin],
    data () {
        return {
            disableFuture: false,
            disablePast: false,
            displayPeriodCount: 1,
            milestone: {
                title: '',
                startDate: '',
            },
            isEditing: false,
            showDate: this.thisMonth(1),
            useDefaultTheme: true,
        }
    },
    computed: {
        userLocale () {
            return this.getDefaultBrowserLocale
        },
        dayNames () {
            return this.getFormattedWeekdayNames(this.userLocale, 'long', 0)
        },
        themeClasses () {
            return {
                'theme-default': this.useDefaultTheme,
            }
        },
        milestones () {
            return this.$store.getters['milestones/milestones']
        },
    },
    methods: {
        periodChanged (range, eventSource) {
            // Demo does nothing with this information, just including the method to demonstrate how
            // you can listen for changes to the displayed range and react to them (by loading items, etc.)
        },
        thisMonth (d, h, m) {
            const t = new Date()
            return new Date(t.getFullYear(), t.getMonth(), d, h || 0, m || 0)
        },
        onClickDay (d) {
        },
        onClickItem (e) {
            this.milestone = { ...e.originalItem }
            this.isEditing = true
        },
        setShowDate (d) {
            this.showDate = d
        },
        onDrop (item, date) {
            // this.message = `You dropped ${item.id} on ${date.toLocaleDateString()}`
            // Determine the delta between the old start date and the date chosen,
            // and apply that delta to both the start and end date to move the item.
            const eLength = this.dayDiff(item.startDate, date)
            item.originalItem.startDate = getFullDate(this.addDays(item.startDate, eLength))
            item.originalItem.startTimestamp = firebase.firestore.Timestamp.fromDate(new Date(item.startDate))

            this.$store.dispatch('milestones/edit', { ...item.originalItem })
        },
        addMilestone () {
            const milestone = {
                startDate: this.milestone.startDate,
                startTimestamp: firebase.firestore.Timestamp.fromDate(new Date(this.milestone.startDate)),
                title: this.milestone.title,
                classes: 'purple-light',
            }

            this.$store.dispatch('milestones/add', milestone)
            this.reset()
        },
        editMilestone () {
            const milestone = {
                startDate: this.milestone.startDate,
                startTimestamp: firebase.firestore.Timestamp.fromDate(new Date(this.milestone.startDate)),
                title: this.milestone.title,
                id: this.milestone.id,
                classes: 'purple-light',
            }

            this.$store.dispatch('milestones/edit', milestone)
            this.isEditing = !this.isEditing
            this.reset()
        },
        deleteMilestone () {
            this.$store.dispatch('milestones/delete', this.milestone.id)
            this.reset()
        },
        loadMilestones () {
            this.$store.dispatch('milestones/load')
        },
        cancelEdditing () {
            this.isEditing = !this.isEditing
            this.reset()
        },
        reset () {
            this.isEditing = false
            this.milestone = {
                title: '',
                startDate: this.isoYearMonthDay(this.today()),
            }
        },
    },
    mounted () {
        this.reset()
    },
    created () {
        this.loadMilestones()
    },
}
</script>

<style>
.calendar-parent {
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    overflow-x: hidden;
    overflow-y: hidden;
    max-height: 100vh;
    background-color: white;
}

/* For long calendars, ensure each week gets sufficient height. The body of the calendar will scroll if needed */
.cv-wrapper.period-month.periodCount-1 .cv-week,
.cv-wrapper.period-year .cv-week {
    min-height: 4rem;
}
.theme-default .cv-day.today {
    background-color: #efeaf4;
}

.theme-default .cv-item.purple-light {
    background-color: #d1c1e0;
    border-color: #c1add6;
}

/* drag hover style */
.theme-default .cv-day.draghover {
    box-shadow: inset 0 0 0.1em 0.1em #663399;
}
</style>
